/**
 * EL PERIODO QUE ENTIENDE GET /api/v1/businesses/{id}/finanzas (PANEL-SALDOS-PERIODO-T1, #15802).
 *
 * DE DONDE SALE. SaldosView cae al resumen de flujo cuando GET /saldos falla, y ese resumen
 * pide /finanzas con buildQuery, que escribe period, from y to: las claves de ingresos,
 * egresos y creditos. BusinessFinanzasController.GetFinanzas lee OTRAS: periodo (default
 * month), desde y hasta, y sus valores son today, week, month, total o range. Resultado:
 * la tarjeta decia total y el agregado venia del mes (#15504).
 *
 * LA REGLA: /finanzas recibe periodo, desde y hasta; los codigos de las vistas en espanol
 * (hoy, semana, mes, rango) se traducen; un rango con fechas va como range. Las listas
 * (ingresos, egresos, creditos) siguen con sus claves: no se tocan.
 *
 * Sin DOM: lo prueba scripts/check-saldos-periodo.mjs.
 */

const PERIODOS = { hoy: 'today', semana: 'week', mes: 'month', rango: 'range', today: 'today', week: 'week', month: 'month', total: 'total', range: 'range' };

/** El query string de /finanzas, con '?' si hay algo. */
export function queryDeFinanzas(filtros = {}) {
  const f = filtros || {};
  const qs = new URLSearchParams();
  const desde = f.desde || f.from;
  const hasta = f.hasta || f.to;
  let periodo = PERIODOS[String(f.periodo || f.period || '').toLowerCase()] || '';
  if (desde || hasta) periodo = 'range';
  if (periodo) qs.set('periodo', periodo);
  if (desde) qs.set('desde', desde);
  if (hasta) qs.set('hasta', hasta);
  if (f.estado) qs.set('estado', f.estado);
  if (f.page) qs.set('page', String(f.page));
  if (f.pageSize) qs.set('pageSize', String(f.pageSize));
  const s = qs.toString();
  return s ? `?${s}` : '';
}
